import { useTranslation } from 'react-i18next';

export function PublicOfferExpiredPage() {
  const { t } = useTranslation('offers');
  return (
    <div
      className="flex min-h-screen items-center justify-center overflow-x-hidden"
      data-testid="public-offer-expired-page"
    >
      <div className="mx-auto max-w-sm px-4 text-center">
        <p className="text-base font-medium text-muted-foreground">
          {t('publicOffer.linkExpired')}
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          {t('publicOffer.linkExpiredDescription')}
        </p>
      </div>
    </div>
  );
}

export function PublicOfferInvalidPage() {
  const { t } = useTranslation('offers');
  return (
    <div
      className="flex min-h-screen items-center justify-center overflow-x-hidden"
      data-testid="public-offer-invalid-page"
    >
      <div className="mx-auto max-w-sm px-4 text-center">
        <p className="text-base font-medium text-muted-foreground">
          {t('publicOffer.linkInvalid')}
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          {t('publicOffer.linkInvalidDescription')}
        </p>
      </div>
    </div>
  );
}
